// D:\my-website\src\components\Footer.js

import React from 'react';
import { useTranslation } from 'react-i18next'; // 引入国际化钩子

function Footer() {
  const { t } = useTranslation(); // 使用国际化钩子

  return (
    <footer className="bg-gray-800 text-white py-8 rounded-t-lg">
      <div className="container mx-auto px-4 md:px-6 text-center text-sm">
        {/* 使用国际化文本显示版权信息 */}
        <p>{t('footer_copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer;
